import { render, staticRenderFns } from "./CadastroNascimento.vue?vue&type=template&id=f4e4919e&"
import script from "./CadastroNascimento.vue?vue&type=script&lang=js&"
export * from "./CadastroNascimento.vue?vue&type=script&lang=js&"
import style0 from "./CadastroNascimento.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports